/**
 * i8 落地页懒加载：首屏 section 不处理，其余进入视口后再加载。
 * 图片依赖 lazysizes；视频用 IntersectionObserver（比 lazysizes 对 video 更可靠）。
 */
(() => {
  const VIDEO_ROOT_MARGIN = '900px 0px';
  const IMAGE_EXPAND = 900;
  const ABOVE_FOLD_MARGIN = 480;
  let initialized = false;
  const initialViewportHeight = window.innerHeight;

  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = IMAGE_EXPAND;
  window.lazySizesConfig.expFactor = 2;
  if (window.lazySizes && window.lazySizes.cfg) {
    window.lazySizes.cfg.expand = IMAGE_EXPAND;
    window.lazySizes.cfg.expFactor = 2;
  }

  const getSections = () => {
    const main = document.getElementById('MainContent');
    if (!main) return [];
    return Array.from(main.querySelectorAll(':scope > .shopify-section'));
  };

  const isSectionAboveFold = (section) => {
    const rect = section.getBoundingClientRect();
    return rect.top < initialViewportHeight + ABOVE_FOLD_MARGIN && rect.bottom > 0;
  };

  const activateVideo = (video) => {
    if (!video || video.dataset.i8VideoReady === '1') return;
    video.dataset.i8VideoReady = '1';

    const src = video.getAttribute('data-src');
    const type = video.getAttribute('data-type') || 'video/mp4';
    const poster = video.getAttribute('data-poster');

    if (poster && !video.getAttribute('poster')) {
      video.setAttribute('poster', poster);
    }

    if (src && !video.querySelector('source') && !video.getAttribute('src')) {
      const source = document.createElement('source');
      source.src = src;
      source.type = type;
      video.appendChild(source);
    }

    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
      }
    });

    video.classList.remove('lazyload');
    video.classList.add('lazyloaded');
    video.setAttribute('preload', 'metadata');
    video.setAttribute('autoplay', '');
    video.load();

    const play = () => {
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };

    if (video.readyState >= 2) {
      play();
    } else {
      video.addEventListener('loadeddata', play, { once: true });
    }
  };

  const observeVideo = (video) => {
    if (!video || video.dataset.i8LazyVideoBound === '1') return;
    video.dataset.i8LazyVideoBound = '1';

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            activateVideo(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: VIDEO_ROOT_MARGIN, threshold: 0.01 }
      );
      observer.observe(video);
    } else {
      activateVideo(video);
    }
  };

  const unveilEagerImage = (img) => {
    if (!img) return;
    img.classList.remove('lazyload');
    img.classList.add('lazyloaded');
    if (img.dataset.src && !img.getAttribute('src')) {
      img.setAttribute('src', img.dataset.src);
    }
    if (img.dataset.srcset && !img.getAttribute('srcset')) {
      img.setAttribute('srcset', img.dataset.srcset);
    }
    img.loading = 'eager';
  };

  const markAboveFold = (section) => {
    section.setAttribute('data-i8-above-fold', 'true');
    section.querySelectorAll('img.lazyload').forEach(unveilEagerImage);
    section.querySelectorAll('video.i8-lazy-video, video.lazyload').forEach(activateVideo);
  };

  const processBelowFold = (section) => {
    section.querySelectorAll('video.i8-lazy-video, video.lazyload').forEach(observeVideo);
  };

  const init = () => {
    const sections = getSections();
    if (!sections.length) return false;

    sections.forEach((section) => {
      if (isSectionAboveFold(section)) {
        markAboveFold(section);
        return;
      }
      processBelowFold(section);
    });

    // Swiper 切页后新露出的视频
    document.addEventListener(
      'transitionend',
      () => {
        document.querySelectorAll('video.i8-lazy-video.lazyload').forEach(observeVideo);
      },
      true
    );

    initialized = true;
    return true;
  };

  const boot = () => {
    if (init()) return;
    window.setTimeout(() => init(), 100);
    window.setTimeout(() => init(), 400);
  };

  document.documentElement.classList.add('i8-lazysizes-enabled');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
